import * as actionTypes from '../actions/actionsTypes';
import { updateObject } from '../../utils/common';

const initialState = {
  shipmentId: '',
};

const setShipmentId = (state, action) => {
  return updateObject(state, {
    shipmentId: action.data,
  });
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SETSHIPMENTID:
      return setShipmentId(state, action);
    default:
      return state;
  }
};

export default reducer;
